import { useErrors } from '@auth0/auth0-acul-react/mfa-sms-list';
import BaseWrapper from 'creative-ui/oktaComponents/BaseWrapper';
import { useTranslation } from 'react-i18next';

import { AuthErrorBanner } from '@/components/AuthErrorBanner/AuthErrorBanner';
import Text from '@/components/Typography/Text/Text';
import { useTrackErrors } from '@/hooks/useTrackErrors';
import { useTransactionLocale } from '@/hooks/useTranslationLocale';

import PhoneNumberList from './components/PhoneNumberList';
import { useMfaSmsListManager } from './hooks/useMfaSmsListManager';

function MfaSmsListScreen() {
  const { t } = useTranslation('mfaSmsList');
  useTransactionLocale();

  const { texts, handleBackAction } = useMfaSmsListManager();

  const { errors } = useErrors();

  const { generalErrorMessages } = useTrackErrors(errors, 'mfa/sms/list/error');

  // SDK first, i18n fallback
  document.title = texts?.pageTitle || t('page.title');

  const title = texts?.title || t('header.title');
  const description = texts?.description || t('header.description');

  return (
    <BaseWrapper title={title} backCtaProps={{ onClick: handleBackAction }}>
      <Text align="center" className="u-margin-b-l">
        {description}
      </Text>
      <AuthErrorBanner errors={generalErrorMessages} />
      <PhoneNumberList />
    </BaseWrapper>
  );
}

export default MfaSmsListScreen;
